import {Injectable} from "@angular/core";
import {PdfColorSettingsRepository} from "../../repositories/pdf-color-settings-repository";
import {Observable, switchMap} from "rxjs";
import {PdfColorSettings} from "../../models/pdf-color-settings.model";

@Injectable({
  providedIn: 'root'
})
export class PdfColorSettingsService {

  constructor(private readonly repo: PdfColorSettingsRepository) {}

  getDefaults(): Observable<PdfColorSettings> {
    return this.repo.getDefaults();
  }

  getForPartner(partnerId: number): Observable<PdfColorSettings> {
    return this.repo.getForPartner(partnerId).pipe(
      switchMap(settings => settings ? [settings] : this.repo.getDefaults())
    );
  }

  saveForPartner(partnerId: number, settings: PdfColorSettings): Observable<PdfColorSettings> {
    return this.repo.saveForPartner(partnerId, settings);
  }
}
